import { createTheme } from '@mui/material/styles';

export type ColorMode = 'light' | 'dark';

const typography = {
  fontFamily: '"Source Sans 3", "Segoe UI", sans-serif',
  h1: {
    fontFamily: '"Source Serif 4", Georgia, serif',
    fontWeight: 600,
    letterSpacing: '-0.02em',
    lineHeight: 1.15,
  },
  h2: {
    fontFamily: '"Source Serif 4", Georgia, serif',
    fontWeight: 600,
    letterSpacing: '-0.02em',
    lineHeight: 1.2,
  },
  h3: {
    fontFamily: '"Source Serif 4", Georgia, serif',
    fontWeight: 600,
    lineHeight: 1.3,
  },
  button: {
    textTransform: 'none' as const,
    fontWeight: 600,
  },
};

/** Light and dark palettes share the brand blue and red. Dark uses them at full strength. */
export const createAppTheme = (mode: ColorMode) => {
  const light = mode === 'light';

  return createTheme({
    palette: {
      mode,
      primary: light
        ? { main: '#0066b2', dark: '#004e8a', contrastText: '#ffffff' }
        : { main: '#3ea6ff', dark: '#0066b2', light: '#8fceff', contrastText: '#ffffff' },
      secondary: {
        main: light ? '#dc052d' : '#ff3d5c',
        dark: light ? '#a80422' : '#dc052d',
        contrastText: '#ffffff',
      },
      background: light
        ? { default: '#f4f6f8', paper: '#ffffff' }
        : { default: '#050910', paper: '#122033' },
      text: light
        ? { primary: '#102033', secondary: '#4d5d6d' }
        : { primary: '#f4f8fc', secondary: '#c5d4e4' },
      divider: light ? '#e2e8ee' : '#3d5f86',
    },
    typography,
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 6,
          },
          ...(light
            ? {}
            : {
                containedPrimary: {
                  backgroundColor: '#0066b2',
                  color: '#ffffff',
                  '&:hover': { backgroundColor: '#0080e0' },
                },
                outlinedPrimary: {
                  borderColor: '#3ea6ff',
                  color: '#8fceff',
                  '&:hover': {
                    borderColor: '#8fceff',
                    backgroundColor: 'rgba(62, 166, 255, 0.14)',
                  },
                },
              }),
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: light ? '#f4f6f8' : '#050910',
          },
        },
      },
    },
  });
};

const theme = createAppTheme('light');

export default theme;
